// extracted by mini-css-extract-plugin
export default {"card":"DefaultAvatarSelect_card__i6ov0","header":"DefaultAvatarSelect_header__vgrK2"};